const FALLBACK_MESSAGE = "Hmm. That’s not supposed to happen. Something is wrong. Can you email support@cottonbureau.com so we can take a look?";

// Flattens an `errors` payload into a list of strings. Handles Laravel's
// ValidationException shape ({field: [msg, ...]}), a plain array of strings,
// and a bare string.
function flattenErrors(errors) {
  if (typeof errors === "string") {
    return errors.trim() === "" ? [] : [errors];
  }

  if (!errors || typeof errors !== "object") {
    return [];
  }

  return Object.values(errors)
    .flat(Infinity)
    .filter((error) => typeof error === "string" && error.trim() !== "");
}

// A 422 ValidationException body is {message, errors}, where `message` is just
// the first error (plus "(and N more errors)"), so show the flattened errors
// alone when there are any, else `message`.
export function retrieveErrors(errorResponse) {
  const data = errorResponse?.response?.data;

  if (!data) {
    return FALLBACK_MESSAGE;
  }

  const errors = flattenErrors(data.errors);

  if (errors.length > 0) {
    return errors.join(" ");
  }

  if (typeof data.message === "string" && data.message !== "" && data.message !== "Server Error") {
    return data.message;
  }

  return FALLBACK_MESSAGE;
}
